document.addEventListener("DOMContentLoaded", function () {

    const header = document.querySelector("header");
    let headerHeight = header.offsetHeight;
    let prevScrollPos = window.scrollY;
    let isHomePage = window.location.pathname === '/';

    window.addEventListener('scroll', function () {
        const currentScrollPos = window.scrollY;
        const isScrollingUp = prevScrollPos > currentScrollPos;
        const isScrolledLessThanThreshold = currentScrollPos < 100;

        if (headerHeight < header.offsetHeight) {
            headerHeight = header.offsetHeight;
        }

        if (isScrolledLessThanThreshold && window.innerWidth <= 768) {
            header.classList.remove('h-20');
            header.classList.add('h-24');
            if (isHomePage) {
                header.classList.remove('bg-flugan-gray-darkest');
            }
        }

        else if (isScrolledLessThanThreshold || isScrollingUp) {
            header.style.top = "0";
            header.classList.add('is-active');
            if (isScrolledLessThanThreshold && isHomePage) {
                header.classList.remove('bg-flugan-gray-darkest');
            }

        } else {
            if (window.innerWidth <= 768) {
                // Make header thinner on mobile
                header.classList.remove('h-24');
                header.classList.add('h-20');
            } else {
                header.style.top = `-${headerHeight}px`;
                header.classList.remove('is-active');
            }

            if (!isHomePage || !isScrolledLessThanThreshold) {
                header.classList.add('bg-flugan-gray-darkest');
            }
        }

        prevScrollPos = currentScrollPos;
    });
});

//# sourceMappingURL=main.js.map
